const style = theme => ({
  searchBar: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 8,
    alignItems: 'center',
  },
  button: {
    width: '20%',
  },
  content: {
    overflowX: 'hidden',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    justifyContent: 'center',
  },
  imageList: {
    padding: 2,
    alignContent: 'flex-start',
    overflow: 'hidden',
  },
  imageItem: {
    marginBottom: 5,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  unsplashPanel: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    flexDirection: 'column',
  },
})

export default style
